// extracted by mini-css-extract-plugin
module.exports = {"container":"_33FvffqxPjhXKtnrp9qXOU","disclaimer":"cZdN-TtJWb6QMbMM4M_eF"};